module.exports = __webpack_public_path__ + "static/media/todo.850d46ac.png";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/todo.png
 ** module id = 423
 ** module chunks = 0
 **/